// src/components/ui/EmptyState.jsx
import { Box, Button, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { useNavigate } from "react-router-dom";

export default function EmptyState({ title, subtitle, actionLabel, actionTo }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 1.5,
      }}
    >
      <InboxOutlinedIcon sx={{ fontSize: 56, opacity: 0.22 }} />
      <Typography sx={{ fontWeight: 900, fontSize: 20 }}>{title}</Typography>
      {subtitle && (
        <Typography sx={{ opacity: 0.6, maxWidth: "40ch" }}>{subtitle}</Typography>
      )}
      {actionLabel && actionTo && (
        <Button
          variant="outlined"
          sx={{ mt: 1, borderRadius: 2, fontWeight: 900 }}
          onClick={() => navigate(actionTo)}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
